<script setup>
import { computed, onMounted, ref } from 'vue'
import { api } from '../services/api'
import { store } from '../store'

const subjects = ref([])
const program = ref(null)
const error = ref('')
const loading = ref(true)
const grade = computed(() => store.user?.role === 'student' ? store.user.grade : null)

onMounted(async () => {
  try {
    const [subjectData, programData] = await Promise.all([api('/subjects'), api('/program-info')])
    subjects.value = subjectData.subjects
    program.value = programData
  } catch (err) { error.value = err.message }
  finally { loading.value = false }
})
</script>

<template>
  <header><p class="eyebrow">Kho học liệu{{ grade ? ` lớp ${grade}` : '' }}</p><h1 class="page-title">{{ grade ? 'Chọn môn học của em' : 'Chương trình học' }}</h1><p class="page-subtitle">Kiến thức được chia nhỏ theo học kỳ, chương và bài. Học đến đâu, luyện chắc đến đó.</p></header>
  <div v-if="error" class="error-banner" style="margin-top:20px">{{ error }}</div>
  <div v-if="loading" class="loading-block"><div><div class="loader"></div><p>Đang mở kho học liệu…</p></div></div>
  <div v-else-if="!error && !subjects.length" class="card empty-state"><strong>{{ grade ? `Chưa có học liệu lớp ${grade}` : 'Chưa có học liệu' }}</strong>Các môn học sẽ xuất hiện khi được bổ sung vào chương trình.</div>
  <section v-else-if="!error" class="subjects-grid">
    <component :is="subject.is_published ? 'RouterLink' : 'article'" v-for="subject in subjects" :key="subject.id" :to="subject.is_published ? `/mon-hoc/${subject.slug}` : undefined" class="card subject-card" :class="[subject.color, { disabled: !subject.is_published }]">
      <span v-if="!subject.is_published" class="chip purple coming-soon">Sắp ra mắt</span>
      <span v-else-if="subject.series" class="chip blue coming-soon">{{ subject.series === 'Global Success' ? 'Global Success' : 'Kết Nối Tri Thức' }}</span>
      <div class="subject-icon">{{ subject.icon }}</div>
      <h2>{{ subject.title }}</h2>
      <small v-if="!grade">Lớp {{ subject.grade }}</small>
      <p>{{ subject.description }}</p>
      <template v-if="subject.is_published">
        <div class="subject-progress-label"><span>{{ subject.progress.completed }}/{{ subject.progress.total }} bài đã học</span><b>{{ subject.progress.percent }}%</b></div>
        <div class="progress-track"><span :style="{ width: `${subject.progress.percent}%` }"></span></div>
      </template>
      <div v-else class="subject-progress-label"><span>Đang chuẩn bị học liệu</span><b>2027</b></div>
    </component>
  </section>
  <div v-if="program" class="info-note"><i>i</i><div><strong>{{ program.name }} · {{ program.school_year }}</strong><br>Toán, Ngữ văn: Kết Nối Tri Thức. Tiếng Anh: Global Success. {{ program.note }}</div></div>
</template>
